// Pre-filled URLs for Indie Law's three source-of-truth spreadsheets.
// Joey can override at sync time via the UI.
export const INDIE_LAW_SHEETS = {
  monthly_goals: {
    label: "Monthly Goals to $1.6M",
    description: "Per-month revenue + sales targets vs actuals (incl. ad spend split Google/Meta).",
    drives: "Forecast targets, Targets page, Recovery Console default goal.",
    url: "https://docs.google.com/spreadsheets/d/1rMhP8AkpL96C-8FidLiiLniV-umthBdbhQCcx49VgN8/edit?usp=sharing",
    endpoint: "/import/monthly-goals",
  },
  sales_snapshot: {
    label: "Sales Snapshot",
    description: "Current-month MTD revenue, sales, and qualified calls by source.",
    drives: "Recovery Console MTD, Dashboard 'Live snapshot' callout.",
    url: "https://docs.google.com/spreadsheets/d/1r39A7ccSlspC2mzw9cLibJ8c5xeEhzacidZHIJkPAaQ/edit?usp=sharing",
    endpoint: "/import/sales-snapshot",
  },
  metrics_tracker: {
    label: "Metrics Tracker",
    description: "Operational initiatives with monthly goals + actuals + On/Off Track status.",
    drives: "Initiatives page (operational levers context).",
    url: "https://docs.google.com/spreadsheets/d/1gdtZs6Ryn6bgbl6H2FuhQSNh9FwHg3FoV5FC2bl6Hr4/edit?usp=sharing",
    endpoint: "/import/metrics-tracker",
  },
  railtown_monthly: {
    label: "Railtown Monthly Snapshot",
    description: "Vendor-managed per-platform monthly Clicks, CTR, CPC, Cost + GA4 traffic context.",
    drives: "Recovery Part 2 traffic-quality strip. BHAG stays authoritative on spend.",
    url: "https://docs.google.com/spreadsheets/d/1CJHSw1gXzRRvYIIfEtqYnl4i0wwLAgduE8irGWsnwXE/edit?usp=sharing",
    endpoint: "/import/railtown-monthly",
  },
};
